import { desktopTruncateStyle } from '~/styles/utilities.css';

type Props = {
  name: string;
};

export const CustomConditionNameCell = ({ name }: Props) => {
  return <div className={desktopTruncateStyle}>{name}</div>;
};
